module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-147-min.4c720689.jpg";